import { useMutation, useQueryClient } from '@northladder/services';

import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';
import { INotificationViewedParam } from '../types';

import { FETCH_NOTIFICATION_HISTORY_QUERY } from './useNotificationHistoryListQuery';
import { FETCH_NOTIFICATION_UN_UNREAD_STATUS } from './useUnreadNotificationQuery';

/**
 * This is to track the notification viewed mutation keys in react query cache.
 */
const MUT_NOTIFICATION_VIEWED = 'notification-viewed-mutation-key';

/**
 * This performs Notification viewed api call and update the state using query
 *  client
 */
export const useNotificationViewedMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isPending, error } = useMutation({
    mutationKey: [MUT_NOTIFICATION_VIEWED],
    retry: false,
    mutationFn: async (
      payload: INotificationViewedParam & { markAll?: boolean }
    ) => {
      const { markAll, ...notificationPayload } = payload;

      return USER_ACCOUNTS_API.updateNotificationViewedStatus(
        notificationPayload,
        markAll
      );
    },
    onSuccess: (_) => {
      queryClient.invalidateQueries({
        queryKey: [FETCH_NOTIFICATION_HISTORY_QUERY],
      });

      queryClient.invalidateQueries({
        queryKey: [FETCH_NOTIFICATION_UN_UNREAD_STATUS],
      });
    },
  });

  return {
    error,
    isPending,
    mutate,
  };
};
